import { ChangeDetectorRef, Directive, HostListener, NgModule, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

import { FilestackService, PickerFileMetadata } from '@hiptraveler/core/filestack';

@Directive({
  selector: '[supportTicketUpload]'
})
export class SupportTicketUploadDirective implements OnDestroy {
  subscription$ = new Subject<void>();

  constructor(
    private cdRef: ChangeDetectorRef,
    private filestack: FilestackService
  ) { }

  ngOnDestroy(): void {
    this.subscription$.next();
  }

  @HostListener('click')
  openFilestackPicker(): void {
    const detectChanges = () => {
      setTimeout(() => this.cdRef.detectChanges());
    };

    this.filestack.openFilestackPicker({
      accept: ['image/jpeg', 'image/jpg', 'image/png'],
      maxFiles: 1,
      maxSize: 1024 * 1024 * 10, // 10MB limit
      customText: {
        'Upload': 'Add Screenshots',
        'Drag and drop files here': 'Drag and drop your screenshots here or click to select (JPG or PNG formats only)',
        'or Drag and Drop, Copy and Paste Files': 'or drag and drop your screenshots here (JPG or PNG formats only)',
        'Select Files to Upload': 'Add Screenshots (JPG or PNG formats only)'
      } as any,
      onClose: detectChanges,
      onUploadDone: detectChanges,
      onFileUploadFinished: this.onFileUploadFinished.bind(this)
    });
  }

  private onFileUploadFinished(metadata: PickerFileMetadata): void {
    // Emit the file URL to parent component
    const event = new CustomEvent('fileUploaded', {
      detail: { url: metadata.url, filename: metadata.filename }
    });
    window.dispatchEvent(event);
    
    setTimeout(() => this.cdRef.detectChanges());
  }
}

@NgModule({
  declarations: [SupportTicketUploadDirective],
  exports: [SupportTicketUploadDirective],
})
export class SupportTicketUploadDirectiveModule { }
